import React from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import AddToolTip from "../../components/AddToolTip";
import { find, get, isEmpty } from "lodash";
import upload from "../../styles/upload.png";
import sftp from "../../styles/ftp.png";
import create from "../../styles/create.png";
const FileTypeWithExt = ({ fileName, uploadedThrough }) => {
  return (
    <div>
      <p className="word-wrap-name excel-text ft-14 m-0">
        {fileName && fileName.length >= 23 ? (
          <AddToolTip
            className="ft-14 font-weight-500 pb-3 company-name"
            name={fileName}
          >
            <p className="ft-14 black-text font-weight-500 mt-10 mb-0 d-flex">
              <div
                style={{
                  width: "24px",
                  height: "18px",
                  marginRight: "5px",
                }}
              >
                <Image
                  src={
                    uploadedThrough == "FileUpload"
                      ? upload
                      : uploadedThrough == "CreatePayroll"
                      ? create
                      : sftp
                  }
                  className="mr-2"
                />{" "}
              </div>
              <p className="d-flex">
                {(fileName || "").slice(0, 18)}... &nbsp;
                <p className="grey-text">
                  {(fileName || "").slice(
                    fileName.indexOf("."),
                    fileName.length
                  )}
                </p>
              </p>

              {/* {data.description} */}
            </p>
          </AddToolTip>
        ) : (
          <p className="ft-14 black-text font-weight-500 mt-10 mb-10">
            <Image
              src={uploadedThrough == "FileUpload" ? upload : sftp}
              className="mr-2"
            />{" "}
            {fileName}
          </p>
        )}
      </p>
    </div>
  );
};

export default FileTypeWithExt;
